/**
 * Türkiye cep telefonu kuralları.
 *
 * Teslimat numarası kargo firmasına gidiyor ve orada +90'lı, 5 ile başlayan on haneli bir
 * numara olmak zorunda; formda serbest metin bırakmak bu doğrulamayı sipariş sonrasına
 * erteliyordu. Alan artık yalnız on hane kabul ediyor, "+90" sabit önek olarak duruyor ve
 * geçersiz numara müşteri yazarken söyleniyor. Operatör önekleri kargo tarafındaki
 * `normalizeTurkishPhone` ile aynı: bu formu geçen numara orada da geçer.
 */

const MOBILE_PREFIXES = /^5(0[0-9]|3[0-9]|4[0-9]|5[0-9])/;

export const PHONE_NATIONAL_LENGTH = 10;

/** Kullanıcının yazdığından yalnız rakamları alır ve on haneye kırpar. */
export function toNationalDigits(value: string): string {
  let digits = value.replace(/\D/g, '');
  // Yapıştırılan numaralar sık sık ülke kodu veya baştaki sıfırla geliyor.
  if (digits.startsWith('0090')) digits = digits.slice(4);
  else if (digits.startsWith('90') && digits.length > PHONE_NATIONAL_LENGTH) digits = digits.slice(2);
  if (digits.startsWith('0')) digits = digits.slice(1);
  return digits.slice(0, PHONE_NATIONAL_LENGTH);
}

/** "532 123 45 67" — okunurluk için gruplar; değer olarak saklanmaz. */
export function formatNationalDigits(digits: string): string {
  const parts = [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 8), digits.slice(8, 10)];
  return parts.filter((part) => part !== '').join(' ');
}

/** Boşsa `undefined`; hatalıysa müşteriye gösterilecek tek cümle. */
export function nationalPhoneError(digits: string): string | undefined {
  if (digits === '') return undefined;
  if (!digits.startsWith('5')) return 'Cep telefonu 5 ile başlamalı (örn. 532 123 45 67).';
  if (digits.length < PHONE_NATIONAL_LENGTH) return 'Numaranın 10 hanesini de girin.';
  if (!MOBILE_PREFIXES.test(digits)) return 'Geçerli bir operatör kodu girin (50, 53, 54, 55…).';
  if (/^(\d)\1{9}$/.test(digits)) return 'Geçerli bir cep telefonu girin.';
  return undefined;
}

export function isValidNationalPhone(digits: string): boolean {
  return digits.length === PHONE_NATIONAL_LENGTH && nationalPhoneError(digits) === undefined;
}

/** Sunucuya ve kargoya giden biçim. */
export function toE164(digits: string): string {
  return digits === '' ? '' : `+90${digits}`;
}
